var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container is-fluid",class:{ 'sidebar-padding-left': _vm.isSidebarOpen }},[_c('Items')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }